export class Companion {

    public id: string = "0";
    public name: string;
    public event_id: string;
    public event_name: string;
    public member_id: string;
    public member_name: string;
    public date: Date;
    
    constructor() {}
    
}
